import { render, staticRenderFns } from "./DetailDialog.vue?vue&type=template&id=71a64b08&scoped=true&lang=pug"
import script from "./DetailDialog.vue?vue&type=script&lang=ts"
export * from "./DetailDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_css-loader@6.11.0_webpack@5.109.2_postcss@8_1f9207239c89e69c02e913826d327f44/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a64b08",
  null
  
)

export default component.exports